module.exports = __webpack_public_path__ + "img/new_secKill_bg2.a1d691b8.png";